import { Component, Input, OnInit, Output,  EventEmitter} from '@angular/core';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';

@Component({
  selector: 'app-mensualidad',
  templateUrl: './mensualidad.component.html',
  styleUrls: ['./mensualidad.component.scss'],
})
export class MensualidadComponent implements OnInit {
   Datos = []
   @Input() UserID =""
   @Output() desabilitar = new EventEmitter();
   disabled: boolean=true;
   
   @Input() Hijos = JSON.parse(atob(localStorage.getItem(btoa("Hijos"))))
   constructor( private conexion: ConexionService, private utilidades: UtilidadesService,
    ) { }

  ngOnInit() {
   setTimeout(() => {
    this.getMensualidadMisEstudiantes()
   }, 100);
  }

  
  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 160) {
        return true;
      }
    }
    return false;
  }




  Sumar(){
    let total = 0;
    for(let i of this.Datos){
      total += Number(i.CuotaNeta)
    }

    return total;
  }
  

  getMensualidadMisEstudiantes() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getMensualidadMisEstudiantes(this.UserID).subscribe((resp) => {
      this.desabilitar.emit(false)
      this.disabled=false;
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.Datos = resp.Datos
        this.utilidades.Depuracion(resp.Datos, "console", "")
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
      this.desabilitar.emit(true)
      this.disabled=false;
      this.utilidades.ValidarUser(err)
    })
  }

  getFoto(idestudiante){
    for(let i of this.Hijos){
      if(i.Id==idestudiante){
        return i.Url
      }
    }
    return ""
  }
}
